module.exports = __webpack_public_path__ + "img/narrow.be5030ca.webp";